import Column from '@components/column'
import CardHeading from '@commons/headings/card'
import { StyleFormGrid } from './style'
import Fields from '@components/fields'
import Constant from '@utils/constant'
import { FC } from 'react'
import ChooseSpecializations from '@commons/specializations'

interface ProviderProfileDetailsProps {
  setFieldValue?: any
  errors?: any
  values?: any
  disabled?: boolean
}
const ProviderProfileDetails: FC<ProviderProfileDetailsProps> = ({
  setFieldValue,
  errors,
  values,
  disabled = false,
}) => {
  return (
    <Column
      rowGap={20}
      styleColumn="border-radius:8px;padding:20px;"
      bg="white"
    >
      <CardHeading title="Personal Information" />
      <StyleFormGrid>
        <Fields.Input
          name="name"
          placeholder="Full Name"
          label="Full Name"
          disabled={disabled}
        />
        <Fields.Input
          type="email"
          name="email"
          placeholder="Email"
          label="Email"
          disabled={disabled}
        />
        <Fields.PhoneInput
          name="phoneNo"
          placeholder="Phone No"
          label="Phone No"
          disabled={disabled}
        />
        <Fields.Input
          name="address"
          placeholder="Address"
          label="Address"
          disabled={disabled}
        />
        <Fields.DropDown
          name="staffRole"
          placeholder="Select"
          options={[
            {
              title: 'Nurse',
            },
            {
              title: 'Pharmacist',
            },
          ]}
          titleAsKey="title"
          valueAsKey="title"
          label="Role"
        />
        <Fields.Input
          name="qualification"
          placeholder="Qualification"
          label="Qualification"
          disabled={disabled}
        />
        <Fields.DropDown
          options={Constant.genders}
          name="gender"
          placeholder="Select Gender"
          label="Gender"
          titleAsKey="name"
          valueAsKey="value"
          disabled={disabled}
        />
        <Fields.Input
          type="number"
          name="yos"
          placeholder="Year of Service"
          label="Year of Service"
          disabled={disabled}
        />
        <Fields.DropDown
          name="category"
          placeholder="Select"
          label="Category"
          options={[
            {
              title: 'Basic',
            },
            {
              title: 'Emergency',
            },
            {
              title: 'Nutrition',
            },
          ]}
          titleAsKey="title"
          valueAsKey="title"
        />
        <ChooseSpecializations
          disabled={disabled}
          isError={errors?.specializations}
          selectedItems={values?.specializations}
          onChange={(item: any) => {
            const findIndex = values?.specializations?.findIndex(
              (selected: any) => selected?.id == item.id,
            )
            if (findIndex >= 0) {
              setFieldValue(
                'specializations',
                values?.specializations?.filter(
                  (symptom) => symptom?.id != item?.id,
                ),
              )
            } else {
              setFieldValue('specializations', [
                ...values?.specializations,
                item,
              ])
            }
          }}
        />
      </StyleFormGrid>
    </Column>
  )
}

export default ProviderProfileDetails
